"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuList = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_select_1 = require("react-select");
var DEFAULT_MAX_HEIGHT = 1200;
var BUFFER_SIZE = 40;
var DEFAULT_PADDING = 8;
exports.MenuList = function (props) {
    var _a = props.selectProps, id = _a.id, maxMenuHeight = _a.maxMenuHeight;
    var selectElement = document.getElementById(id);
    var maxHeight = maxMenuHeight && typeof maxMenuHeight === 'number'
        ? maxMenuHeight
        : DEFAULT_MAX_HEIGHT;
    var menuListElement = selectElement === null || selectElement === void 0 ? void 0 : selectElement.querySelector('.fos__menu-list');
    react_1.useLayoutEffect(function () {
        if (selectElement && menuListElement) {
            var menuListSize = menuListElement.getBoundingClientRect();
            var maxHeightVal = window.innerHeight - menuListSize.top - BUFFER_SIZE - DEFAULT_PADDING;
            var maxHeightStyle = (maxHeightVal > maxHeight ? maxHeight : maxHeightVal) + "px";
            menuListElement.style.maxHeight = maxHeightStyle;
        }
    }, [selectElement, menuListElement, maxHeight]);
    return react_1.default.createElement(react_select_1.components.MenuList, tslib_1.__assign({}, props));
};
exports.MenuList.displayName = 'FOS_ReactSelect_MenuList';
